//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('gridExports', {
//        templateUrl: 'views/components/views/gridExports/gridExports.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'gridExportsService', function ($stateParams, gridExportsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let argType = $stateParams.argtype;
//            let argValue = $stateParams.argvalue;
            
//            vm.model = {
//                itemsListGridExports: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadGridExports() {
//                vm.model.itemsListGridExports = await gridExportsService.listGridExports({
//                    argtype: argType,
//                    argvalue: argValue
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadGridExports();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
